/**
 * 影片嵌入連結處理工具
 * @param url: String  原始影片連結
 * @returns String  處理後的嵌入連結
 */

export function provideEmbedPath() {
  /**
   * Youtube 支援格式
   * 1. youtube:${id}
   * 2. https://www.youtube.com/watch?v=${id}
   * 3. https://youtu.be/${id}
   *
   * 因為 Cookie 隱私權法規的關係，Youtube 影片的網址要改成 nocookie 的網址
   */

  const provideYoutubeEmbedPath = (url: string): string => {
    if (url.indexOf('youtube:') === 0) {
      const id: string = url.split(':')[1];
      return `https://www.youtube-nocookie.com/embed/${id}`;
    }

    if (url.indexOf('https://') === 0) {
      if (url.includes('youtube')) {
        const query: string = url.split('?')[1];
        const params: URLSearchParams = new URLSearchParams(query);
        const id: string | null = params.get('v');
        if (id) {
          return `https://www.youtube-nocookie.com/embed/${id}`;
        }
      } else if (url.includes('youtu.be')) {
        const params: string = url.split('?')[0];
        const id: string = params.split('/').pop() || '';
        if (id) {
          return `https://www.youtube-nocookie.com/embed/${id}`;
        }
      }
    }
    return url;
  };

  /**
   * Bilibili 支援格式
   * 1. bilibili:{id}
   * 2. https://www.bilibili.com/video/{id}
   * 3. https://player.bilibili.com/player.html?bvid=${id}
   */

  const provideBilibiliEmbedPath = (url: string): string => {
    if (url.indexOf('bilibili:') === 0) {
      const id: string = url.split(':')[1];
      return `https://player.bilibili.com/player.html?bvid=${id}`;
    }

    if (url.indexOf('https://www.bilibili.com/') === 0) {
      const params: string = url.split('?')[0];
      const _routePart: string[] = params.split('/');
      const routePart: string[] = _routePart.filter((item) => item !== '');
      const id: string = routePart.pop() || '';
      if (id) {
        return `https://player.bilibili.com/player.html?bvid=${id}`;
      }
    }
    return url;
  };

  /**
   * WistiaMedia 支援格式
   * 1. https://advantech.wistia.com/medias/{id}
   */

  const provideWistiaMediaEmbedPath = (url: string): string => {
    if (url.includes('advantech.wistia.com')) {
      const params: string = url.split('?')[0];
      const items: string[] = params.split('/');
      const code: string = items[items.length - 1];
      return `https://fast.wistia.net/embed/iframe/${code}`;
    }
    return url;
  };

  return {
    provideYoutubeEmbedPath,
    provideBilibiliEmbedPath,
    provideWistiaMediaEmbedPath,
  };
}
